(function ($) {
    const registrationSection = document.querySelector(".event-registration");
    const registrationForm = document.getElementById("event-registration-form");
    const nextButton = document.getElementById("nextButton");
    var optionalFields = "";
    var formErrors = 0;

    //Load Classes
    if (document.getElementById("event-registration-form") != null) {
        loadClass();

        document.addEventListener("change", function (e) {
            let field = e.target.closest(".required-field");
            if (field) {
                validateForm();
            }
        });

        nextButton.addEventListener('click', function () {
            if (validateForm()) {
                //hide current fields
                $("#event-registration-form .bhsf-col-2").hide()
                $("#event-registration-form .bhsf-col-4").hide()

                //hide Next button and show Submit button
                $("[id=registerSubmit]").show();
                $("[id=nextButton]").hide();

                //Change title to Options
                var optionsTitle = $("[id=optionsTitle").html();
                $("[id=upcomingEvents").html(optionsTitle);

                //Show the optional fields
                $("#country-field").after(optionalFields);
                registrationSection.scrollIntoView();
            }
        });

        registrationForm.addEventListener("submit", function (e) {
            e.preventDefault();
            if (validateForm()) {
                registrationSection.scrollIntoView();
                submitForm();
            }
        });
    }

    function validateForm() {
		let fieldErrors = document.querySelectorAll(".field-error");
		if (fieldErrors.length > 0) {
			fieldErrors.forEach((field) => {
				field.classList.remove("field-error");
			});
		}
        formErrors = 0;

        let requiredFields = document.querySelectorAll(".required-field");
        if (requiredFields.length > 0) {
          requiredFields.forEach((field) => {
            if (field.value === "") {
                formErrors++;
                field.parentElement.classList.add("field-error");
                if (field.parentElement.parentElement.classList.contains('option-field')) {
                    field.parentElement.parentElement.classList.add("field-error");
                }
              }
              if (field.type == "checkbox" || field.type == "radio") {
                  var chkField = document.querySelectorAll('input[name="' + field.name + '"]')
                  var checked = false;
                  for (let i = 0; i < chkField.length; i++) {
                      if (chkField[i].checked) {
                          checked = true;
                          break;
                      }
                  }
                  if (!checked) {
                      formErrors++;
                      field.parentElement.classList.add("field-error");
                      if (field.parentElement.parentElement.classList.contains('option-field')) {
                          field.parentElement.parentElement.classList.add("field-error");
                      }
                  }
              }
          });
        }
        return formErrors === 0 ? true : false;
    }

    function getTimestamp() {
        var date = new Date();
        var components = [
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        ];

        return components.join("");
    }


    function submitForm() {
        let formElements = registrationForm.elements;
        let formData = {};
        for (var i = 0; i < formElements.length; i++) {
            if (formElements[i].name == null || formElements[i].name == "") {
                continue;
            }
            formData[formElements[i].name] = formElements[i].value;
        }

        var ClassGuests = [];
        var GuestOptions = [];
        var iOptionOrder = 1;

        //Guest Options Submit
        $("#event-registration-form .bhsf-col-1").each(function (j) {
            if ($(this).find('label.option-label').length > 0) {
                var inputElement = $(this).find('div.option-value > input:first');
                var inputType = inputElement.attr('type');
                if (inputType == null) {
                    inputElement = $(this).find('div.option-value > textarea:first');
                    inputType = 'textarea';
                } // if
                var inputLabel = $(this).find('label.option-label').html().replace(' (*)', '');
                var inputValue = '';

                switch (inputType) {
                    case 'text':
                        inputValue = inputElement.val();
                        break;
                    case 'radio':
                        var inputName = inputElement.attr('name');
                        inputValue = $(this).find('div.option-value > input:radio[name="' + inputName + '"]:checked').val();
                        break;
                    case 'checkbox':
                        $(this).find('div.option-value > input').each(function () {
                            if ($(this).is(':checked')) {
                                if (inputValue === '') {
                                    inputValue = $(this).val();
                                } else {
                                    inputValue = inputValue + ', ' + $(this).val();
                                }
                            }
                        });
                        break;
                    case 'file':
                        var uploadName = inputElement.attr('name');
                        var divuploadname = 'div' + uploadName;
                        var divupload = document.getElementById(divuploadname);
                        var data = new FormData();
                        var file = $(this).find('div.option-value > input[type="file"]')[0];
                        var configPath = "https://uat.events.apps.baptisthealth.net";
                        var fileName = getTimestamp() + "_" + file.files[0].name.replace(/[^._a-zA-Z0-9]/g, '');
                        data.append('attachment[name]', fileName);
                        data.append('attachment[file]', renameFile(file.files[0], fileName));
                        data.append('type', "classRegistration");
                        inputValue = $("#eToolsUrl").val() + "/uploads/" + fileName.replace("C:\\fakepath\\", "");
                        xhr = new XMLHttpRequest();
                        xhr.open("post", $("#eToolsUrl").val() + "/_handlers/AjaxFileUploader.ashx", true);
                        xhr.onreadystatechange = function () {
                            debugger;
                            if (xhr.readyState == 4) {
                                if (xhr.status === 200) {
                                    console.log(xhr.responseText)
                                }
                                else {
                                    console.log("Error", xhr.statusText);
                                }
                            }
                        };
                        xhr.addEventListener('loadend', () => {
                            debugger;
                        });
                        xhr.send(data);
                        break;
                    case 'textarea':
                        inputValue = inputElement.val();
                        break;
                    default:
                        inputValue = '';
                        break;
                }

                if ((typeof inputValue === 'undefined') || (inputValue === '')) {
                    inputValue = '';
                }

                if (inputValue != '') {
                    if (inputType == 'file') {
                        //inputValue = '/uploads/' + inputValue;
                    }
                }

                // Add class guest option.
                GuestOptions.push(
                    {
                        Name: inputLabel,
                        Value: inputValue,
                        OptionOrder: iOptionOrder

                    }
                );

                iOptionOrder++;
            }
        });
        if (GuestOptions.length > 0) {
            //Guest Options Submit end
            ClassGuests.push(
                {
                    ClassID: formData["ClassID"],
                    FirstName: formData["RegistrantFirstName"],
                    LastName: formData["RegistrantLastName"],
                    GuestOptions: GuestOptions
                });
        }

        formData["ClassGuests"] = ClassGuests;
        var dtoRegistration = { 'dto': formData };
        // fetch call to service
        let url = $("#eToolsUrl").val() + "/_services/ClassesAndEventsService.asmx/InsertRegistration";
        let options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dtoRegistration),
        };
        fetch(url, options)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (data.d == null || data.d.IsSuccessful == false) {
                  $("[id=submitFailed]").show();
                  return;
                }

                //Success Confirmation
                $("[id=divConfirmation]").show();
                $("[id=pName").html(formData["RegistrantFirstName"]);
                $("[id=pLastName").html(formData["RegistrantLastName"]);
                $("[id=pAddress").html(formData["RegistrantAddress1"]);

                var location = formData["RegistrantCity"];
                if (location != null && location != "" && formData["RegistrantState"] != null && formData["RegistrantState"] != "") {
                    location += ", " + formData["RegistrantState"];
                } else {
                    location = formData["RegistrantState"];
                }

                if (location != null && location != "" && formData["RegistrantZip"] != null && formData["RegistrantZip"] != "") {
                    location += ", " + formData["RegistrantZip"];
                } else {
                    location = formData["RegistrantZip"];
                }

                $("[id=pCityStateZip").html(location);
                $("[id=pPhone").html(formData["RegistrantPhone"]);
                $("[id=pEmail").html(formData["RegistrantEmail"]);

                var optionsToDisplay = "";
                GuestOptions.forEach(function (guestOption) {
                    optionsToDisplay += "<p>" + guestOption.Name + ": " + guestOption.Value + "</p>";
                });
                $("[id=pRegOptions").html(optionsToDisplay);

                $("[id=registrationContainer]").hide();

            })
            .catch((error) => {
                $("[id=submitFailed]").show();
                console.error("Fetch error:", error);
            });
    }


    function loadClass() {
        var match = RegExp('[?&]' + "ceid" + '=([^&]*)').exec(window.location.search);
        var classID = match && decodeURIComponent(match[1].replace(/\+/g, ' '));
        if (classID) {
            $.ajax({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: $("#eToolsUrl").val() + "/_services/ClassesAndEventsService.asmx/SelectClass",
                data: '{"classID": "' + classID + '"}',
                success: function (msg) {
                    theClass = msg.d;
                    if (theClass.IsRegistrationOpen == true) {

                        //Display the header
                        $("[id=page-header-title").html(theClass.Title);
                        $("#classId").val(theClass.ClassID);
                        var tagsToDisplay = "";
                        tags = theClass.AssignedTags;
                        tags.forEach(function (tag) {
                            if (tag != null && tag.TagName != null) {
                                tagsToDisplay += tag.TagName + " | ";
                            }

                        });
                        if (tagsToDisplay.length > 0) {
                            tagsToDisplay = tagsToDisplay.trim();
                            tagsToDisplay = tagsToDisplay.substring(0, tagsToDisplay.length - 1).trim();
                            $("[id=page-header-type").html(tagsToDisplay);
                        }

                        //Check if need to display Options and Next Button
                        if (theClass.RegistrationOptions.length > 0) {
                            //$("[id=registerSubmit]").hide();
                            //$("[id=nextButton]").show();
                            optionalFields = updateRegistration(theClass.RegistrationOptions);
                            //Adding the additional fields while loading.
                            $("#country-field").after(optionalFields);
                        }


                    } else {
                        $(':input[type="submit"]').hide();
                        $("[id=submitDisabled]").show();
                    }
                },
                error: function (msg) {
                    $(':input[type="submit"]').hide();
                    $("[id=noClassParameter]").show();
                }
            });

        } else {

            $(':input[type="submit"]').hide();
            $("[id=noClassParameter]").show();

        }
    }

    function uploadFile(uploadinput) {
        // Upload file and display results.
        $.ajaxFileUpload({
            url: "/_handlers/AjaxFileUploader.ashx",
            secureuri: false,
            fileElementId: uploadinput,
            dataType: 'json',
            data: { name: 'logan', id: 'id', type: 'classRegistration' },
            success: function (data, status) {
                if (typeof (data.error) != 'undefined') {
                    if (data.error == '') {
                        var curdiv = 'div' + uploadinput;
                        var divupload = document.getElementById(curdiv);
                        divupload.innerHTML = data.fileName;
                    } // if
                } // if
            },
            error: function (data, status, e) {
            }
        });
        return false;
    }

    function renameFile(originalFile, newName) {
        return new File([originalFile], newName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    function updateRegistration(theRegistrationOptions) {
        var optionsHtml = "";
        // Add registration option fields.
        $.each(theRegistrationOptions, function (j, value) {
            var isRequired = value.IsRequired ? ' <span class="field-validator" style="color:Red;visibility:hidden;">Required</span>' : '';
            var isRequiredLabel = value.IsRequired ? '(*)' : '';
            var isRequiredClass = value.IsRequired ? ' required-field' : '';
            var isRequiredLabelClass = value.IsRequired ? 'required' : '';

            var fieldLabel = value.Label;
            var option = '<div id="' + fieldLabel + '" class="bhsf-col-1 option-field">' +
                '<label class="option-label ' + isRequiredLabelClass +'">' + fieldLabel + '</label><br>';


            switch (value.InputType) {
                case RegistrationOption.TextBox:
                    option += '<div class="option-value"><input class="' + isRequiredClass + '" type="text" name="' + fieldLabel + '"/></div>';
                    break;
                case RegistrationOption.RadioButtons:
                    var items = value.Options.split(',');
                    var $items = $('<div></div>');
                    $.each(items, function (k, value) {
                        value = $.trim(value);
                        $('<input class="' + isRequiredClass + '" type="radio" name="' + fieldLabel + '" value="' + value + '" /><label>' + value + '</label>').appendTo($items);
                    });
                    option += '<div class="option-value">' + $items.html() + '</div>';
                    break;
                case RegistrationOption.Checkboxes:
                    var items = value.Options.split(',');
                    var $items = $('<div></div>');
                    $.each(items, function (k, value) {
                        value = $.trim(value);
                        $('<input class="' + isRequiredClass + '" type="checkbox" name="' + fieldLabel + '" value="' + value + '" /><label>' + value + '</label>').appendTo($items);
                    });
                    option += '<div class="option-value">' + $items.html() + '</div>';
                    break;
                case RegistrationOption.FileUpload:
                    var $items = $('<div></div>');
                    $('<div class="option-value"><input class="' + isRequiredClass + '" type="file" id="upload' + j.toString() + '" name="upload' + j.toString() + '" /></div>').appendTo($items);
                    option += $items.html();
                    break;
                case RegistrationOption.TextArea:
                    option += '<div class="option-value"><textarea class="' + isRequiredClass + '" rows="4" cols="50" name="' + fieldLabel + '"/></div>';
                    break;
                default:
                    break;
            }

            option += isRequired + '</div>';
            optionsHtml += option;
        });
        return optionsHtml;
    }


})(jQuery);


var RegistrationOption = {
    TextBox: 0,
    RadioButtons: 1,
    Checkboxes: 2,
    FileUpload: 3,
    TextArea: 4
};